"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var useStaticFunction_1 = __importDefault(require("./useStaticFunction"));

function useComputed(state, deps) {
  var setter = useStaticFunction_1.default(function (key, value) {
    var descriptor = Object.getOwnPropertyDescriptor(state, key);

    if (descriptor.set) {
      descriptor.set(value);
    } else {
      state[key] = value;
    }
  });
  var computed = react_1.useMemo(function () {
    var descriptors = Object.getOwnPropertyDescriptors(state);

    var _loop_1 = function _loop_1(key) {
      var descriptor = descriptors[key];

      if (descriptor.set) {
        descriptor.set = function (value) {
          return setter(key, value);
        };
      }
    };

    for (var key in descriptors) {
      _loop_1(key);
    }

    return Object.defineProperties({}, descriptors);
  }, deps);
  return computed;
}

exports.default = useComputed;